import { useContext } from "react";
import { Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";

import { DescarteDeTerrenoContext } from "./contextoDeDescarte";

interface BotonDescartarDeTerrenoProps {
  /** El bloque que se descarta: foto, audio, texto, registro o ítem creado en terreno. */
  uuid: string;
  /** Qué se descarta y dónde: nombra el botón para quien no ve la tarjeta. */
  etiqueta: string;
}

/**
 * «Descartar»: manda el bloque a la papelera. NEUTRO y sin confirmación, porque
 * se deshace (el rojo queda para «Vaciar papelera», lo único irreversible).
 */
export function BotonDescartarDeTerreno({ uuid, etiqueta }: BotonDescartarDeTerrenoProps) {
  const descartar = useContext(DescarteDeTerrenoContext);

  if (!descartar) return null;

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      className="text-ink-muted size-7 flex-none"
      aria-label={`Descartar ${etiqueta}`}
      title="Descartar"
      onClick={() => descartar(uuid)}
    >
      <Trash2 className="size-3.5" aria-hidden="true" />
    </Button>
  );
}
